import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

import { Icon } from '@/components/icon';
import { Logo } from '@/components/logo';
import { company } from '@/data/company';

import { MobileNav, type NavItem } from './mobile-nav';

const navItems: NavItem[] = [
  { to: '/baumpflege', label: 'Baumpflege', icon: 'TreeDeciduous' },
  { to: '/baumhausbau', label: 'Baumhausbau', icon: 'Hammer' },
  { to: '/baumfaellung', label: 'Baumfällung', icon: 'Axe' },
  { to: '/referenzen', label: 'Referenzen', icon: 'Eye' },
  { to: '/ueber-uns', label: 'Über uns', icon: 'Award' },
  { to: '/kontakt', label: 'Kontakt', icon: 'Mail' },
];

export function Header(): React.ReactNode {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-stone bg-paper/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-8">
        <Link to="/" aria-label="Zur Startseite">
          <Logo variant="dark" className="h-9 w-auto" />
        </Link>

        <nav className="hidden items-center gap-5 lg:flex" aria-label="Hauptnavigation">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 text-sm font-medium transition-colors ${
                  isActive ? 'text-bark' : 'text-mute hover:text-bark'
                }`
              }
            >
              <Icon name={item.icon} className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-2 lg:flex">
          <a
            href={company.whatsapp.href}
            className="inline-flex items-center gap-1 rounded-md border border-stone px-3 py-2 text-sm hover:border-bark"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <Icon name="MessageCircle" className="h-4 w-4" />
            WhatsApp
          </a>
          <a
            href={company.phone.href}
            className="inline-flex items-center gap-1 rounded-md bg-bark px-3 py-2 text-sm text-paper hover:bg-moss"
          >
            <Icon name="Phone" className="h-4 w-4" />
            {company.phone.display}
          </a>
        </div>

        <button
          type="button"
          className="lg:hidden"
          aria-label="Menü öffnen"
          aria-expanded={mobileOpen}
          onClick={() => {
            setMobileOpen(true);
          }}
        >
          <Icon name="Menu" className="h-6 w-6" />
        </button>
      </div>

      <MobileNav
        isOpen={mobileOpen}
        onClose={() => {
          setMobileOpen(false);
        }}
        items={navItems}
      />
    </header>
  );
}
